module.exports = "https://static.energy5.com/_next/static/images/windowsDoorsBg-cafad117073ffaee02b3e9ab8f1828e6.webp";